// Import your images
import art from './art.png';
import ecom from './ecom.png';
import tth from './tth.png'; // Add more images as necessary
import './App.css';

function Portfolio() {
  return (
    <div className="portfolio-container">
      <h1 className="portfolio-title">My Work</h1>

      <div className="projects-grid">

        {/* First project */}
        <div className="project-card">
        <a href="https://dl-rlr-gideons-projects-4df1104c.vercel.app/">
          <img className="project-img" src={art} alt="Custom E-Commerce Store" />
          <div className="project-info">
            <h2 className="project-title">Custom Web Designers</h2>
            <p className="project-description">
              A fully responsive and SEO-optimized online web designing store built with React
            </p>
          </div>
          </a>
        </div>

        {/* Second project */}
        <div className="project-card">
          <img className="project-img" src={tth} alt="Modern Portfolio Website" />
          <div className="project-info">
            <h2 className="project-title">Website still under development</h2>
            <p className="project-description">
            Website still under development and will not open
            </p>
          </div>
        </div>

        {/* Third project */}
        <div className="project-card">
          <img className="project-img" src={ecom} alt="Corporate Redesign" />
          <div className="project-info">
            <h2 className="project-title">Website still under development</h2>
            <p className="project-description">
             Website still under development and will not open
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Portfolio;
